import { servidor } from "../servidor";

/**
 * Modifica un producto existente en el sistema mediante el endpoint `/movilabs/modifyProduct`.
 *
 * @async
 * @function modifyProduct
 * @param {Object} item - Objeto con los datos modificados del producto.
 * @param {string} store - Identificador de la tienda asociada al producto.
 * @param {string} branch - Identificador de la sucursal donde se encuentra el producto.
 * @param {string} user - Identificador del usuario que realiza la modificación.
 * @returns {Promise<Object>} Objeto con la respuesta del servidor tras la modificación.
 * @throws {Error} Si ocurre un error en la solicitud, ya sea por red, código de estado inesperado
 *                 o un mensaje de error del servidor.
 */
export const modifyProduct = async (item, store, branch, user) => {
  try {
    const response = await servidor.patch("/movilabs/modifyProduct", {
      item,
      store,
      branch,
      user
    });
    if (response.status !== 200) {
      throw new Error(`Error: Received status code ${response.status}`);
    }
    // console.log('response', response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching modify product data:", error);

    // Si el servidor responde con un error (como 400 o 500)
    if (error.response && error.response.data) {
      const serverMsg = error.response.data.msg || error.response.data.error;
      throw new Error(serverMsg || "Error desconocido del servidor.");
    }

    // Error de red u otra excepción
    throw new Error("Servicio no disponible. Inténtalo más tarde.");
  }
};
